import { render } from "./WorkList.vue?vue&type=template&id=894033f4&scoped=true"
import script from "./WorkList.vue?vue&type=script&lang=js"
export * from "./WorkList.vue?vue&type=script&lang=js"

import "./WorkList.vue?vue&type=style&index=0&id=894033f4&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894033f4"]])

export default __exports__